import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import {
    ApiService,
    Mk2Request,
    Mk2Response,
    Pagination
} from '@lsq-frontend/angular-shared/api-service';
import { ISettings, SETTINGS } from '@lsq-frontend/angular-shared/settings';

export class AdminCompleteBuyerImplementationRequest extends Mk2Request {
    buyerImplementationKey?: string;

    constructor(initial?: Partial<AdminCompleteBuyerImplementationRequest>) {
        super();
        if (initial != null) {
            Object.keys(initial).forEach((key) => {
                this[key] = initial[key];
            });
        }
    }
}

export class AdminCompleteBuyerImplementationResponse extends Mk2Response {
    buyerKey?: string;
    companyContactKey?: string;
    companyKey?: string;
    configurationKey?: string;
    fboConfigurationKey?: string;

    constructor(initial?: Partial<AdminCompleteBuyerImplementationResponse>) {
        super();
        if (initial != null) {
            Object.keys(initial).forEach((key) => {
                this[key] = initial[key];
            });
        }
    }
}

@Injectable({ providedIn: 'root' })
export class CompleteImplementationService extends ApiService<
    AdminCompleteBuyerImplementationRequest,
    AdminCompleteBuyerImplementationResponse
> {
    public requestType = AdminCompleteBuyerImplementationRequest;
    public responseType = AdminCompleteBuyerImplementationResponse;
    public endpointName = 'operations/AdminCompleteBuyerImplementation/CompleteImplementation';
    public serviceName = 'financing';
    constructor(http: HttpClient, @Inject(SETTINGS) settings: ISettings) {
        super(http, settings);
    }
}
